module.exports = __webpack_public_path__ + "static/patriciawork7-73a1f76528123360b2c3a57f5ec9a13f.jpg";